import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    ProfileOutlined,
    QuestionCircleOutlined,
    SearchOutlined,
    ClockCircleOutlined,
    MailOutlined,
    FileTextOutlined,
    CalendarOutlined,
    UserOutlined,
    HomeOutlined,
} from "@ant-design/icons";

import {
    Button,
    Card,
    Checkbox,
    Col,
    Form,
    Input,
    Modal,
    notification,
    Popconfirm,
    Row,
    Select,
    Skeleton,
    Tag,
    Space,
    theme,
} from "antd";

import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomHeader from "../common/Header";
import CustomTable from "../common/Table";
import { getUserRole, weekDays } from "../../services/util";

const { Option } = Select;
const CheckboxGroup = Checkbox.Group;

const frequencyOfReport = [
    {
        key: 1,
        title: "Daily",
        color: "var(--color-success)",
        bg: "var(--color-success-light)",
        border: "var(--color-success)",
    },
    {
        key: 2,
        title: "Weekly",
        color: "var(--color-accent)",
        bg: "var(--color-accent-light)",
        border: "var(--color-accent)",
    },
    {
        key: 3,
        title: "Monthly",
        color: "var(--color-primary)",
        bg: "var(--color-primary-light)",
        border: "var(--color-primary)",
    },
    {
        key: 4,
        title: "Yearly",
        color: "var(--color-warning)",
        bg: "var(--color-warning-light)",
        border: "var(--color-warning)",
    },
    {
        key: 5,
        title: "Shift-Based",
        color: "var(--color-error)",
        bg: "var(--color-error-light)",
        border: "var(--color-error)",
    },
];

const reportFormates = [
    { key: "1", title: "HTML", icon: "🌐" },
    { key: "2", title: "PDF", icon: "📄" },
];

const customFields = [
    { key: "checkin_count", title: "Check-Ins" },
    { key: "reservation_count", title: "Reservations" },
    { key: "walkin_count", title: "Walk-Ins" },
    { key: "checkout_count", title: "Check-Outs"},
    { key: "cash_collected", title: "Cash Collected" },
    { key: "cash_dispence", title: "Cash Dispense" },
    { key: "review", title: "Reviews" },
    { key: "transaction_avg_checkins", title: "Avg Checkin Time" },
    { key: "transaction_avg_walkins", title: "Avg Walkin Time" },
    { key: "new_calls_count", title: "Kiosk Calls" },
    { key: "call_logs", title: "Call Logs" },
    { key: "call_logs_count", title: "Call Logs Count" },
    { key: "hk_order_count", title: "HK Orders" },
    { key: "hk_ticket_count", title: "HK Tickets" },
    { key: "mnt_ticket_count", title: "Maintenance Tickets" },
    { key: "dinning_order_count", title: "Dining Orders" },
    { key: "walk_in_logs", title: "WalkIn Logs" },
    { key: "self_checkin_count", title: "Self Check-In" },
    { key: "shift_notes_count", title: "Shift Notes" },
    { key: "missed_call_rate", title: "Missed Call Rate" },
    { key: "reservation_calllogs_count", title: "Number of Reservation Calls" },
    {
        key: "successful_reservation_calllogs_count",
        title: "Number of Successful Reservations",
    },
    { key: "successful_reservation_rate", title: "Reservation Success Rate" },
];

const getReportFields = (keys) =>
    keys
        .map((key) => customFields.find((field) => field.key === key))
        .filter(Boolean);

const reportFieldGroups = [
    {
        title: "Stay Activity",
        fields: getReportFields([
            "checkin_count",
            "reservation_count",
            "walkin_count",
            "checkout_count",
            "self_checkin_count",
            "transaction_avg_checkins",
            "transaction_avg_walkins",
        ]),
    },
    {
        title: "Payments",
        fields: getReportFields(["cash_collected", "cash_dispence"]),
    },
    {
        title: "Calls & Reservations",
        fields: getReportFields([
            "new_calls_count",
            "call_logs",
            "call_logs_count",
            "missed_call_rate",
            "reservation_calllogs_count",
            "successful_reservation_calllogs_count",
            "successful_reservation_rate",
        ]),
    },
    {
        title: "Service & Operations",
        fields: getReportFields([
            "review",
            "hk_order_count",
            "hk_ticket_count",
            "mnt_ticket_count",
            "dinning_order_count",
            "walk_in_logs",
            "shift_notes_count",
        ]),
    },
];
const getUserEmail = () => {
    if (localStorage.getItem("userEmail")) {
        if (process.env.REACT_APP_ENV == "production") {
            if (['mrunal.desai@aavgo.com', 'jayesh.dabhi@aavgo.com', 'nikunj.tandel@aavgo.com', 'chintak.desai@aavgo.com'].indexOf(localStorage.getItem("userEmail")) !== -1) {
                return true;
            }
        } else {
            if (['jayesh.dabhi@astics.io', 'nikunj.tandel@astics.io', 'milkesh.patel@aavgo.com'].indexOf(localStorage.getItem("userEmail")) !== -1) {
                return true;
            }
        }
    }
    return false;
}
let user_email = false;
const getReportFieldTitle = (key) =>
    customFields.find((field) => field.key === key)?.title;

// ── Shared theme styles ───────────────────────────────
const sectionBox = {
    background: "var(--color-bg-card)",
    border: "1px solid var(--color-border)",
    borderRadius: 12,
    padding: "20px 24px",
    marginTop: 16,
};

const inputStyle = {
    background: "var(--color-bg-control)",
    border: "1px solid var(--color-border)",
    borderRadius: 8,
    color: "var(--color-text)",
    fontSize: 13,
};

const modalStyles = {
    content: {
        background: "var(--color-bg-card)",
        border: "1px solid var(--color-border)",
        borderRadius: 12,
        padding: 28,
    },
    header: {
        background: "var(--color-bg-card)",
        borderBottom: "1px solid var(--color-border)",
        paddingBottom: 16,
    },
    mask: { backdropFilter: "blur(4px)" },
};

function FormLabel({ children }) {
    return (
        <span style={{ color: "var(--color-text-muted)", fontSize: 12 }}>
            {children}
        </span>
    );
}

// ── Section header ────────────────────────────────────
function SectionHeader({ icon, title }) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 16,
            }}
        >
            <div
                style={{
                    width: 3,
                    height: 18,
                    borderRadius: 2,
                    background: "var(--gradient-primary)",
                }}
            />
            {icon && (
                <span style={{ color: "var(--color-primary)", fontSize: 14 }}>
                    {icon}
                </span>
            )}
            <span
                style={{
                    color: "var(--color-text)",
                    fontWeight: 600,
                    fontSize: 15,
                }}
            >
                {title}
            </span>
        </div>
    );
}

// ── Frequency badge ───────────────────────────────────
function FrequencyBadge({ value }) {
    const freq = frequencyOfReport.find((f) => f.key == value);
    if (!freq)
        return <span style={{ color: "var(--color-text-muted)" }}>—</span>;
    return (
        <span
            style={{
                display: "inline-block",
                background: freq.bg,
                border: `1px solid ${freq.border}`,
                color: freq.color,
                borderRadius: 6,
                padding: "2px 10px",
                fontWeight: 600,
                fontSize: 12,
            }}
        >
            {freq.title}
        </span>
    );
}

// ── Format badge ──────────────────────────────────────
function FormatBadge({ formats }) {
    return (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {formats?.map((f) => {
                const fmt = reportFormates.find((rf) => rf.key == f);
                return fmt ? (
                    <span
                        key={f}
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 4,
                            background: "var(--color-bg-elevated)",
                            border: "1px solid var(--color-border)",
                            borderRadius: 6,
                            padding: "2px 9px",
                            color: "var(--color-text-secondary)",
                            fontSize: 12,
                        }}
                    >
                        {fmt.icon} {fmt.title}
                    </span>
                ) : null;
            })}
        </div>
    );
}

function ReportFieldsSummary({ fields = [] }) {
    const selectedGroups = reportFieldGroups
        .map((group) => ({
            ...group,
            fields: group.fields.filter((field) => fields.includes(field.key)),
        }))
        .filter((group) => group.fields.length > 0);

    const knownFieldKeys = new Set(
        reportFieldGroups.flatMap((group) =>
            group.fields.map((field) => field.key),
        ),
    );
    const otherFields = fields
        .filter((field) => !knownFieldKeys.has(field))
        .map((field) => ({ key: field, title: getReportFieldTitle(field) }))
        .filter((field) => field.title);

    const groupsToRender =
        otherFields.length > 0
            ? [...selectedGroups, { title: "Other", fields: otherFields }]
            : selectedGroups;

    if (groupsToRender.length === 0) {
        return <span style={{ color: "var(--color-text-muted)" }}>—</span>;
    }

    return (
        <div style={{ display: "grid", gap: 8, minWidth: 340 }}>
            {groupsToRender.map((group) => (
                <div key={group.title}>
                    <div
                        style={{
                            color: "var(--color-text-muted)",
                            fontSize: 11,
                            fontWeight: 600,
                            marginBottom: 4,
                        }}
                    >
                        {group.title}
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 4,
                        }}
                    >
                        {group.fields.map((field) => (
                            <Tag
                                key={field.key}
                                style={{
                                    background: "var(--color-accent-light)",
                                    border: "1px solid var(--color-accent)",
                                    color: "var(--color-accent)",
                                    borderRadius: 5,
                                    fontSize: 11,
                                    margin: 0,
                                }}
                            >
                                {field.title}
                            </Tag>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}

function HotelsSummary({ names = [] }) {
    if (!names?.length) {
        return <span style={{ color: "var(--color-text-muted)" }}>—</span>;
    }

    const visibleNames = names.slice(0, 2);
    const hiddenCount = names.length - visibleNames.length;

    return (
        <div style={{ display: "grid", gap: 8, minWidth: 260 }}>
            {visibleNames.map((name) => (
                <div
                    key={name}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                    }}
                >
                    <div
                        style={{
                            width: 30,
                            height: 30,
                            borderRadius: 10,
                            background: "var(--color-primary-light)",
                            border: "1px solid var(--color-border)",
                            color: "var(--color-primary)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                        }}
                    >
                        <HomeOutlined style={{ fontSize: 14 }} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            minWidth: 0,
                        }}
                    >
                        <span
                            style={{
                                color: "var(--color-text)",
                                fontSize: 13,
                                fontWeight: 600,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                            title={name}
                        >
                            {name}
                        </span>
                        <span
                            style={{
                                color: "var(--color-text-muted)",
                                fontSize: 11,
                            }}
                        >
                            Report hotel
                        </span>
                    </div>
                </div>
            ))}
            {hiddenCount > 0 && (
                <span
                    style={{
                        color: "var(--color-text-muted)",
                        fontSize: 12,
                        paddingLeft: 40,
                    }}
                >
                    +{hiddenCount} more {hiddenCount === 1 ? "hotel" : "hotels"}
                </span>
            )}
        </div>
    );
}

// ── Table columns ─────────────────────────────────────
function buildColumns(onEdit, onDelete, onHistory, testReportSettings) {
    const { token } = theme.useToken();
    return [
        {
            title: "Hotels",
            dataIndex: "hotel_names",
            width: 320,
            render: (names) => <HotelsSummary names={names} />,
        },
        {
            title: "Report Fields",
            dataIndex: "report_fields",
            width: 420,
            render: (fields) => <ReportFieldsSummary fields={fields} />,
        },
        {
            title: "Time",
            dataIndex: "report_time",
            width: 90,
            render: (t) => (
                <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                    <ClockCircleOutlined
                        style={{
                            color: "var(--color-text-muted)",
                            fontSize: 12,
                        }}
                    />
                    <span
                        style={{
                            color: "var(--color-text-secondary)",
                            fontSize: 13,
                        }}
                    >
                        {t || "—"}
                    </span>
                </div>
            ),
        },
        {
            title: "Format",
            dataIndex: "report_format",
            width: 110,
            render: (formats) => <FormatBadge formats={formats} />,
        },
        {
            title: "Frequency",
            dataIndex: "frequency",
            width: 120,
            filters: [
                {
                    text: "Daily",
                    value: 1,
                },
                {
                    text: "Weekly",
                    value: 2,
                },
                {
                    text: "Monthly",
                    value: 3,
                },
                {
                    text: "Yearly",
                    value: 4,
                },
                {
                    text: "Shift-Based",
                    value: 5,
                },
            ],
            render: (value) => <FrequencyBadge value={value} />,
        },
        {
            title: "Send To",
            dataIndex: "email_ids",
            render: (emails) => (
                <div
                    style={{ display: "flex", flexDirection: "column", gap: 3 }}
                >
                    {emails?.map((email) => (
                        <span
                            key={email}
                            style={{
                                fontSize: 12,
                                color: "var(--color-text-muted)",
                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                            }}
                        >
                            <MailOutlined style={{ fontSize: 11 }} /> {email}
                        </span>
                    ))}
                </div>
            ),
        },
        {
            title: "Created By",
            render: (_, r) => (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div
                        style={{
                            width: 28,
                            height: 28,
                            borderRadius: 8,
                            background: "var(--color-primary-light)",
                            border: "1px solid var(--color-primary)",
                            color: "var(--color-primary)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: 700,
                            fontSize: 11,
                            flexShrink: 0,
                        }}
                    >
                        {r.staff_first_name?.[0]?.toUpperCase() || "?"}
                    </div>
                    <span
                        style={{
                            color: "var(--color-text-secondary)",
                            fontSize: 13,
                        }}
                    >
                        {r.staff_first_name} {r.staff_last_name}
                    </span>
                </div>
            ),
        },
        {
            title: "Actions",
            width: 120,
            render: (_, record) => (
                <div style={{ display: "flex", gap: 4 }}>
                    <Popconfirm
                        title="Delete this report?"
                        description="This action cannot be undone."
                        icon={
                            <QuestionCircleOutlined
                                style={{ color: "var(--color-error)" }}
                            />
                        }
                        onConfirm={() => onDelete(record.id)}
                        okText="Delete"
                        cancelText="Cancel"
                    >
                        <Button
                            type="text"
                            size="small"
                            icon={
                                <DeleteOutlined
                                    style={{ color: token.colorError }}
                                />
                            }
                            style={{
                                background: "var(--color-error-light)",
                                border: "1px solid var(--color-error)",
                                borderRadius: 7,
                                width: 30,
                                height: 30,
                            }}
                        />
                    </Popconfirm>
                    <Button
                        type="text"
                        size="small"
                        icon={
                            <EditOutlined
                                style={{ color: token.colorPrimary }}
                            />
                        }
                        onClick={() => onEdit(record)}
                        style={{
                            background: token.colorBgElevated,
                            border: `1px solid ${token.colorPrimaryDark}`,
                            borderRadius: 7,
                            width: 30,
                            height: 30,
                        }}
                    />
                    {user_email && 
                        <Button
                            type="text"
                            size="small"
                            icon={
                                <MailOutlined
                                    style={{ color: token.colorWarning }}
                                />
                            }
                            onClick={() => testReportSettings(record.id)}
                            style={{
                                background: "var(--color-warning-light)",
                                border: "1px solid var(--color-warning)",
                                borderRadius: 7,
                                width: 30,
                                height: 30,
                            }}
                        />
                    }
                    <Button
                        type="text"
                        size="small"
                        icon={
                            <ProfileOutlined
                                style={{ color: token.colorSuccess }}
                            />
                        }
                        onClick={() => onHistory(record.id)}
                        style={{
                            background: "var(--color-accent-light)",
                            border: "1px solid var(--color-accent)",
                            borderRadius: 7,
                            width: 30,
                            height: 30,
                        }}
                    />
                </div>
            ),
        },
    ];
}

// ── Main component ────────────────────────────────────
function ReportsTable() {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const staff_id = localStorage.getItem("x-dashboard-staffid");

    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState("ADD");
    const [editingReportId, setEditingReportId] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [searchKey, setSearchKey] = useState("");
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [hotelOptions, setHotelOptions] = useState([]);
    const [historyTableData, setHistoryTableData] = useState([]);
    const [tableVisible, setTableVisible] = useState(false);
    const [totalHistoryRecords, setTotalHistoryRecords] = useState(0);

    const [formData, setFormData] = useState({
        staff_id,
        page: 0,
        limit: 10,
        sorting: 1,
        sort_by: "created_at",
        search_by: "",
        filters : {}
    });

    const { status, data, refetch } = useQuery(
        "reports",
        async () => await HTTP("/reports/getReportSettings", formData),
        { enabled: false },
    );

    const { status: hotelStatus, data: hotelData } = useQuery(
        "report-hotels",
        async () =>
            await HTTP("/dashboard/getHotels", { staff_id, hotel_type: "all" }),
    );

    useEffect(() => {
        refetch();
        user_email = getUserEmail();
    }, [formData]);

    useEffect(() => {
        if (status === "success") {
            setTableData(data.data);
            setTotalRecords(data.total);
            user_email = getUserEmail();
        }
    }, [status, data]);

    useEffect(() => {
        if (hotelStatus === "success") {
            setHotelOptions(hotelData?.data || []);
            user_email = getUserEmail();
        }
    }, [hotelStatus, hotelData]);

    function openAddModal() {
        form.resetFields();
        setEditingReportId(null);
        setTitle("Create Report");
        setVisible(true);
    }

    function editReportSettings(record) {
        const hotelIds = record.hotel_id || record.hotel_ids || [];
        const reportFormat = Array.isArray(record.report_format)
            ? record.report_format[0]
            : record.report_format;

        setEditingReportId(record.id);
        form.setFieldsValue({
            hotel_id: Array.isArray(hotelIds) ? hotelIds : [hotelIds],
            report_fields: Array.isArray(record.report_fields)
                ? record.report_fields
                : [],
            frequency: record.frequency,
            week_day: record?.recurring?.week_day,
            week_number: record?.recurring?.week_number,
            report_time: record.report_time,
            email_ids: Array.isArray(record.email_ids)
                ? record.email_ids.join(",")
                : record.email_ids,
            report_format: reportFormat?.toString(),
            shift_start_time: record.shift_start_time,
            shift_end_time: record.shift_end_time,
        });
        setTitle("Edit Report");
        setVisible(true);
    }

    function closeModel() {
        form.resetFields();
        setEditingReportId(null);
        setVisible(false);
    }

    async function handleSubmit(values) {
        const selectedFields = Array.isArray(values.report_fields)
            ? values.report_fields
            : [];
        const existingFieldsRaw =
            tableData.find((report) => report.id === editingReportId)
                ?.report_fields || [];
        const existingFields = Array.isArray(existingFieldsRaw)
            ? existingFieldsRaw
            : [];
        const knownFieldKeys = customFields.map((field) => field.key);
        const hiddenExistingFields = existingFields.filter(
            (field) => !knownFieldKeys.includes(field),
        );
        const reportFields = Array.from(
            new Set([...selectedFields, ...hiddenExistingFields]),
        );
        const frequency = Number(values.frequency);

        const payload = {
            staff_id,
            hotel_id: values.hotel_id,
            report_fields: reportFields,
            frequency,
            recurring: {},
            report_time: values.report_time,
            report_format: Array.isArray(values.report_format)
                ? values.report_format.map((format) => Number(format))
                : [Number(values.report_format)],
            email_ids: Array.isArray(values.email_ids)
                ? values.email_ids
                : String(values.email_ids)
                      .split(",")
                      .map((email) => email.trim())
                      .filter(Boolean),
        };

        if (editingReportId) payload.id = editingReportId;
        if (frequency !== 1 && values.week_day) {
            payload.recurring.week_day = values.week_day;
        }
        if (frequency === 3 && values.week_number) {
            payload.recurring.week_number = values.week_number;
        }
        if (frequency === 5) {
            payload.shift_start_time = values.shift_start_time;
            payload.shift_end_time = values.shift_end_time;
        }

        setSubmitLoading(true);
        try {
            const { success, message, data } = await HTTP(
                editingReportId
                    ? "/reports/editReportSetting"
                    : "/reports/addReportSetting",
                payload,
            );

            if (success) {
                notification.info({
                    message: message || "Action performed successfully.",
                });
                refetch();
                closeModel();
            } else {
                notification.error({
                    message: message || data?.message || "Action failed.",
                });
            }
        } catch (error) {
            notification.error({
                message:
                    error?.message ||
                    error ||
                    "Unable to save report setting.",
            });
        } finally {
            setSubmitLoading(false);
        }
    }

    async function deleteReportSettings(id) {
        const { success, message } = await HTTP(
            "/reports/deleteReportSetting",
            { id, staff_id },
        );
        if (success)
            notification.success({ message: "Report deleted successfully" });
        else notification.error({ message });
        refetch();
    }

    async function testReportSettings(id) {
        const { success, message } = await HTTP(
            "/cron/testReportSettings",
            { id, staff_id },
        );
        if (success)
            notification.success({ message: "Report tested successfully" });
        else notification.error({ message });
        refetch();
    }

    async function showHistory(id) {
        const { success, data, total } = await HTTP(
            "/reports/getReportSettingsHistory",
            { report_id: id },
        );
        if (success) {
            setHistoryTableData(data);
            setTotalHistoryRecords(total);
            setTableVisible(true);
        }
    }

    function handleSearchInputChange(event) {
        const value = event.target.value;
        setSearchKey(value);

        if (!value) {
            setFormData((p) => ({ ...p, page: 0, search_by: "" }));
        }
    }

    function handleSearchInputSubmit() {
        setFormData((p) => ({
            ...p,
            page: 0,
            search_by: searchKey.trim(),
        }));
    }
    function handleTableChange(pagination, filters) {
        setFormData((prev) => ({
            ...prev,
            filters,
        }));
    }

    const columns = buildColumns(
        editReportSettings,
        deleteReportSettings,
        showHistory,
        testReportSettings,
    );

    const isReady = status !== "loading" && status !== "idle";

    // Summary counts
    const totalReports = totalRecords;
    const uniqueHotels = new Set(tableData.flatMap((r) => r.hotel_names || []))
        .size;
    const activeFormats = new Set(
        tableData.flatMap((r) => r.report_format || []),
    ).size;

    return (
        <>
            <Card className="dashboard-container">
                <CustomHeader />

                {/* ── Page header ── */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        margin: "16px 0",
                    }}
                >
                    <div>
                        <h2
                            style={{
                                fontSize: 22,
                                fontWeight: 700,
                                color: "var(--color-text)",
                                margin: 0,
                                letterSpacing: "-0.01em",
                            }}
                        >
                            Report Management
                        </h2>
                        <p
                            style={{
                                fontSize: 13,
                                color: "var(--color-text-muted)",
                                margin: "4px 0 0",
                            }}
                        >
                            Configure automated reports and delivery schedules
                        </p>
                    </div>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={openAddModal}
                    >
                        Create Report
                    </Button>
                </div>

                {/* ── Summary pills ── */}
                {isReady && (
                    <div
                        style={{
                            display: "flex",
                            gap: 12,
                            marginBottom: 4,
                            flexWrap: "wrap",
                        }}
                    >
                        {[
                            {
                                label: "Total Reports",
                                value: totalReports,
                                color: "var(--color-primary)",
                            },
                            {
                                label: "Hotels Covered",
                                value: uniqueHotels,
                                color: "var(--color-accent)",
                            },
                            {
                                label: "Active Formats",
                                value: activeFormats,
                                color: "var(--color-warning)",
                            },
                        ].map(({ label, value, color }) => (
                            <div
                                key={label}
                                style={{
                                    background: "var(--color-bg-card)",
                                    border: `1px solid ${color}33`,
                                    borderRadius: 10,
                                    padding: "10px 20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 2,
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: 20,
                                        fontWeight: 700,
                                        color,
                                    }}
                                >
                                    {value}
                                </span>
                                <span
                                    style={{
                                        fontSize: 11,
                                        color: "var(--color-text-muted)",
                                    }}
                                >
                                    {label}
                                </span>
                            </div>
                        ))}
                    </div>
                )}

                {/* ── Search bar ── */}
                <div style={sectionBox}>
                    <Input
                        prefix={
                            <SearchOutlined
                                style={{ color: "var(--color-text-muted)" }}
                            />
                        }
                        placeholder="Search by hotel name…"
                        value={searchKey}
                        onChange={handleSearchInputChange}
                        onPressEnter={handleSearchInputSubmit}
                        allowClear
                        style={{ ...inputStyle, maxWidth: 320 }}
                        suffix={
                            <Button
                                size="small"
                                type="primary"
                                onClick={handleSearchInputSubmit}
                                style={{
                                    background: "var(--color-primary)",
                                    border: "none",
                                    borderRadius: 6,
                                    fontSize: 12,
                                }}
                            >
                                Search
                            </Button>
                        }
                    />
                </div>

                {/* ── Reports table ── */}
                <div style={sectionBox}>
                    <SectionHeader
                        icon={<FileTextOutlined />}
                        title="Configured Reports"
                    />
                    {!isReady ? (
                        <Skeleton active paragraph={{ rows: 10 }} />
                    ) : (
                        <CustomTable
                            columns={columns}
                            tableData={tableData}
                            noOfrecords={totalRecords}
                            rowKey="id"
                            isScroll
                            handleTableChange={handleTableChange}
                        />
                    )}
                </div>
            </Card>

            {/* ── Create / Edit Modal ── */}
            <Modal
                title={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <div
                            style={{
                                width: 3,
                                height: 18,
                                borderRadius: 2,
                                background: "var(--gradient-primary)",
                            }}
                        />
                        <span
                            style={{
                                color: "var(--color-text)",
                                fontWeight: 600,
                                fontSize: 16,
                            }}
                        >
                            {title}
                        </span>
                    </div>
                }
                open={visible}
                footer={null}
                onCancel={closeModel}
                width={760}
                styles={modalStyles}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSubmit}
                    style={{ marginTop: 8 }}
                >
                    <Form.Item
                        label={<FormLabel>Hotels</FormLabel>}
                        name="hotel_id"
                        rules={[{ required: true, message: "Select hotels." }]}
                    >
                        <Select
                            showSearch
                            mode="multiple"
                            placeholder="Select hotels"
                            loading={hotelStatus === "loading"}
                            maxTagCount="responsive"
                            filterOption={(input, option) =>
                                option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {hotelOptions.map((h) => (
                                <Option
                                    key={h.hotel_id || h.id}
                                    value={h.hotel_id || h.id}
                                >
                                    {`${h.hotel_id || h.id} - ${
                                        h.hotel_name || h.name
                                    }${h.city ? ` - ${h.city}` : ""}`}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label={<FormLabel>Report Time</FormLabel>}
                                name="report_time"
                                rules={[
                                    { required: true, message: "Required" },
                                ]}
                            >
                                <Input
                                    prefix={
                                        <ClockCircleOutlined
                                            style={{
                                                color: "var(--color-text-muted)",
                                            }}
                                        />
                                    }
                                    placeholder="e.g. 08:00"
                                    style={inputStyle}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={<FormLabel>Format</FormLabel>}
                                name="report_format"
                                rules={[
                                    { required: true, message: "Required" },
                                ]}
                            >
                                <Select
                                    placeholder="Select format"
                                    style={{ ...inputStyle }}
                                >
                                    {reportFormates.map((f) => (
                                        <Option key={f.key} value={f.key}>
                                            {f.icon} {f.title}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item
                                label={<FormLabel>Frequency</FormLabel>}
                                name="frequency"
                                rules={[
                                    { required: true, message: "Required" },
                                ]}
                            >
                                <Select placeholder="Select frequency">
                                    {frequencyOfReport.map((f) => (
                                        <Option key={f.key} value={f.key}>
                                            {f.title}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label={
                                    <FormLabel>
                                        Recipients (comma-separated emails)
                                    </FormLabel>
                                }
                                name="email_ids"
                                rules={[
                                    { required: true, message: "Required" },
                                ]}
                            >
                                <Input
                                    prefix={
                                        <MailOutlined
                                            style={{
                                                color: "var(--color-text-muted)",
                                            }}
                                        />
                                    }
                                    placeholder="email1@domain.com,email2@domain.com"
                                    style={inputStyle}
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* Report fields checkbox grid */}
                    <Form.Item
                        label={<FormLabel>Report Fields</FormLabel>}
                        name="report_fields"
                        rules={[
                            {
                                required: true,
                                message: "Select at least one report field.",
                            },
                        ]}
                    >
                        <CheckboxGroup style={{ width: "100%" }}>
                            <div
                                style={{
                                    background: "var(--color-bg-control)",
                                    border: "1px solid var(--color-border)",
                                    borderRadius: 10,
                                    padding: 16,
                                }}
                            >
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns:
                                            "repeat(auto-fit, minmax(290px, 1fr))",
                                        gap: 12,
                                    }}
                                >
                                    {reportFieldGroups.map((group) => (
                                        <div
                                            key={group.title}
                                            style={{
                                                background:
                                                    "var(--color-bg-card)",
                                                border: "1px solid var(--color-border)",
                                                borderRadius: 8,
                                                padding: 12,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent:
                                                        "space-between",
                                                    gap: 10,
                                                    marginBottom: 10,
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        color: "var(--color-text)",
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {group.title}
                                                </span>
                                                <span
                                                    style={{
                                                        color: "var(--color-text-muted)",
                                                        fontSize: 11,
                                                    }}
                                                >
                                                    {group.fields.length} fields
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    display: "grid",
                                                    gridTemplateColumns:
                                                        "repeat(auto-fit, minmax(185px, 1fr))",
                                                    gap: "8px 12px",
                                                }}
                                            >
                                                {group.fields.map((field) => (
                                                    <Checkbox
                                                        key={field.key}
                                                        value={field.key}
                                                        style={{
                                                            color: "var(--color-text-secondary)",
                                                            fontSize: 13,
                                                            lineHeight: 1.35,
                                                            marginInlineStart: 0,
                                                        }}
                                                    >
                                                        {field.title}
                                                    </Checkbox>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </CheckboxGroup>
                    </Form.Item>

                    <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
                        <Button
                            onClick={closeModel}
                            style={{
                                flex: 1,
                                height: 40,
                                borderRadius: 9,
                                background: "var(--color-bg-control)",
                                border: "1px solid var(--color-border)",
                                color: "var(--color-text-secondary)",
                                fontSize: 13,
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={submitLoading}
                            style={{
                                flex: 2,
                            }}
                        >
                            Save Report
                        </Button>
                    </div>
                </Form>
            </Modal>

            {/* ── History Modal ── */}
            <Modal
                title={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <div
                            style={{
                                width: 3,
                                height: 18,
                                borderRadius: 2,
                                background: "var(--gradient-primary)",
                            }}
                        />
                        <CalendarOutlined
                            style={{ color: "var(--color-primary)" }}
                        />
                        <span
                            style={{
                                color: "var(--color-text)",
                                fontWeight: 600,
                                fontSize: 16,
                            }}
                        >
                            Report History
                        </span>
                    </div>
                }
                open={tableVisible}
                footer={null}
                width="75%"
                onCancel={() => setTableVisible(false)}
                styles={modalStyles}
            >
                <CustomTable
                    columns={columns.slice(0, -1)}
                    tableData={historyTableData}
                    noOfrecords={totalHistoryRecords}
                    rowKey="id"
                    isScroll
                />
            </Modal>
        </>
    );
}

export { ReportsTable };
